import { render } from "./ManageWorkspace.vue?vue&type=template&id=01f99ebe&scoped=true"
import script from "./ManageWorkspace.vue?vue&type=script&lang=js"
export * from "./ManageWorkspace.vue?vue&type=script&lang=js"

import "./ManageWorkspace.vue?vue&type=style&index=0&id=01f99ebe&scoped=true&lang=css"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f99ebe"]])

export default __exports__